interface UserAvatarProps {
  photoURL?: string | null;
  displayName?: string | null;
  email?: string | null;
  size?: 'sm' | 'md' | 'lg';
}

const COLORS = [
  'bg-blue-500',
  'bg-purple-500',
  'bg-green-500',
  'bg-yellow-500',
  'bg-red-500',
  'bg-indigo-500',
  'bg-pink-500',
  'bg-teal-500',
];

const SIZES = {
  sm: 'w-8 h-8 text-sm',
  md: 'w-12 h-12 text-lg',
  lg: 'w-16 h-16 text-xl',
};

export function UserAvatar({
  photoURL,
  displayName,
  email,
  size = 'md',
}: UserAvatarProps) {
  const getInitial = () => {
    if (displayName) return displayName[0].toUpperCase();
    if (email) return email[0].toUpperCase();
    return 'U';
  };

  const getColorClass = () => {
    const initial = getInitial();
    const colorIndex = initial.charCodeAt(0) % COLORS.length;
    return COLORS[colorIndex];
  };

  if (photoURL) {
    return (
      <img
        src={photoURL}
        alt={displayName || email || 'User'}
        // className={`${SIZES[size]} rounded-full object-cover`}
        className='w-full h-full object-cover'
        referrerPolicy='no-referrer'
      />
    );
  }

  return (
    <div
      className={`${getColorClass()} w-full h-full rounded-full flex items-center justify-center text-white font-medium`}
    >
      {getInitial()}
    </div>
  );
}
